import React from "react";
import Register from "../components/register";
import { Image } from "antd";
import LoginSider from "../assets/img/loginSliderNew.png";
import LoginLogo from "../assets/img/loginLogo.svg";
import { Flex } from "antd";
import { Link } from "react-router-dom";
import useWindowSize from '../hooks/useWindowSize';

const RegisterPage = () => {
  const isMobile = useWindowSize();

  return (
    <Flex style={{ minHeight: "100vh" }}>
      <div
        style={{
          flex: "1.2",
          background: `url(${LoginSider}) no-repeat center center`,
          backgroundSize: "cover",
          height: "100vh",
          display: isMobile ? 'none' : 'block'
        }}
      ></div>

      <Flex
        style={{
          flex: isMobile ? '1' : '0.8',
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: isMobile ? "20px" : "40px",
          position: "relative",
          backgroundColor: "#fff"
        }}
      >
        <div style={{ maxWidth: "400px", width: "100%" }}>
          <Image 
            preview={false} 
            src={LoginLogo} 
            style={{ 
              width: "62px",
              height: "38px"
            }}
          />
          <h2 
            style={{ 
              color: "#08184F",
              fontSize: "24px",
              marginBottom: "8px"
            }}
          >
            Create an account
          </h2>
          <p style={{ 
            marginBottom: "24px", 
            fontSize: "14px",
            color: "#666" 
          }}>
            Already have an account?{" "}
            <Link to="/login" style={{ 
              color: "#0050b5",
              fontWeight: "bold"
            }}>
              Sign in
            </Link>
          </p>
          <Register />
        </div>

        <div
          style={{
            position: "absolute",
            bottom: "20px",
            width: "100%",
            textAlign: "center",
            color: "#666",
            fontSize: "14px"
          }}
        >
         © {new Date().getFullYear()} Orlando Magic
        </div>
      </Flex>
    </Flex>
  );
};

export default RegisterPage; 
